import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { GetActiveSessionResponseDto } from "../dtos/get-active-session.response.dto";
import { URLS } from "../../constants/constants";
//import { AuthService } from "../../../common/services/auth.service";


@Injectable({ providedIn: 'root' })
export class SessionService {
private http = inject(HttpClient);
//TODO: set a token header or discuss 
//FIXME: private authService = inject(HeaderTokenAuthService)
    
    
    async getActiveSession(sessionId:string) : Promise<GetActiveSessionResponseDto>{
        return  firstValueFrom(this.http.get<GetActiveSessionResponseDto>(`${URLS.DUENDE_CLIENT_API}/active-session?sessionId=${sessionId}`));  
    }
}